<template>
	<article class="content list-page">
		<div v-if="showConsentNotice" class="notice warning">
			<h3>Want more from Tektronix?</h3>
			<div class="column separated">
				<p class="rigid">Would you like to receive marketing communications about the latest Tektronix products, offers and events?</p>
				<footer class="row separated right">
					<button type="button" @click="toggleMarketingOptIn(true)" name="button">Yes, I would</button>
					<button type="button" @click="toggleMarketingOptIn(false)" name="button">No, I wouldn't</button>
				</footer>
			</div>
		</div>

		 <div v-if="user.exportPending" class="notice warning">
		 	<h3>Account Pending</h3>
			<p>
				In compliance with U.S. Government regulation, Tektronix is required to review all software download activity. Our team has been notified and will contact you once your account has been cleared.
				This process may take up to two U.S. business days. We apologize for any inconvenience.
			</p>
			<p>
				If you have any questions, please <a href="mailto:export-control@support.tekcloud.com?subject=Account%20Under%20Review">contact support</a>.
			</p>
		</div>


		<header class="rigid">
			<h1>Welcome, {{user && user.address && user.address.firstName}}</h1>
			<p class="gray-6">Manage your account settings to get the most out of TekCloud.</p>
		</header>

		<!-- turn these into components -->
		<section class="rigid">
			<h3>Quick Actions</h3>
			<div class="row separated separated-extra cards cards-actions">
				<router-link class="gap card card-secondary" to="/codes/redeem">
					<div class="row separated">
						<i class="fas fa-ticket-alt jumbo rigid"></i>
						<span class="flexible card-value gray-6"></span>
					</div>
					<h4>Redeem Prepaid Code</h4>
				</router-link>
				<router-link class="gap card card-secondary" to="/payments/method?returnPath=%2F">
					<div class="row separated">
						<i class="fas fa-credit-card rigid jumbo"></i>
						<span v-if="account && account.paymentMethod" class="flexible card-value gray-5">
							<i class="cc fab" :class="'fa-cc-' + account.paymentMethod.brand.toLowerCase()"></i> {{account.paymentMethod.last4}}
						</span>
					</div>
					<h4 v-if="account && account.paymentMethod">Change Payment Method</h4>
					<h4 v-else>Add Payment Method</h4>
				</router-link>
				<router-link class="gap card card-secondary" to="/address">
					<div class="row separated">
						<i class="fas fa-map-marker-alt rigid jumbo"></i>
						<span v-if="user.address" class="flexible card-value gray-5 trailing-off">{{user.address.addressLine1}}</span>
					</div>
					<h4 v-if="user.address">Change Address</h4>
					<h4 v-else>Add Address</h4>
				</router-link>
			</div>
		</section>

		<!-- turn these into components -->
		<subscriptions></subscriptions>
		<section v-if="!showConsentNotice">
			<h3>Preferences</h3>
			<span class="list-group">
				<setting-toggle
					class="ignore-active"
					can-edit="userStatus.loading"
					v-on:change="toggleMarketingOptIn"
					:model="marketingEnabled"
					:label="'Receive news on latest Tektronix products, offers and events'">
				</setting-toggle>
			</span>
		</section>
	</article>
</template>

<script>
// import SettingToggle from '../components/SettingToggle';
import SettingToggle from '../components/SettingToggle';
import Spinner from '../components/Spinner';
import Subscriptions from '../views/Subscriptions';
import consentService from '@/modules/consent-service';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
	name: 'TekHome',
	computed: {
		...mapGetters([
			'user',
			'userStatus',
			'account'
		]),
		...mapGetters('consent', [
			'showConsentNotice',
			'marketingEnabled'
		]),
		...mapState('consent', [
			'marketingEnabledAnswer'
		]),
	},
	data() {
		return {
			password: '',
			loadingMarketingFlag: false
		};
	},
	components: {
		SettingToggle,
		Subscriptions,
		Spinner
	},
	methods: {
		...mapActions('consent',{
			setMarketingFlag: 'SET_MARKETING_ANSWER'
		}),
		toggleDataCollection(enabled) {
			this.$store.dispatch('RESET_USER_STATUS');
			this.updateDataCollection(enabled);
		},
		toggleMarketingOptIn(enabled) {
			this.$store.dispatch('RESET_USER_STATUS');
			const answer = enabled ? 'yes' : 'no';
			consentService.setMarketingFlag(answer)
				.then(() => {
					this.setMarketingFlag(answer);
				});
		},
		updateDataCollection(enabled) {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('UPDATE_USER_REQUEST', {
					trackingEnabled: enabled
				})
					.then(response => {
						resolve(response);
					})
					.catch(reason => {
						reject(reason);
					});
			});
		},
		// resetState() {
		// 	this.$store.dispatch('RESET_USER_STATUS');
		// }
	},
	created(){
		let vm = this;
		if (!this.marketingEnabledAnswer) {
			consentService.getMarketingFlag()
				.then((answer) => {
					vm.setMarketingFlag(answer);
				});
		}

	},
	mounted(){
		document.documentElement.classList.remove('navigating', 'initializing');
	}
};
</script>



// WEBPACK FOOTER //
// ./src/views/TekHome.vue